import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["criteriaType"]

  connect() {
    this.toggleDecreaseField()
    this.criteriaTypeTargets.forEach(input => {
      input.addEventListener('change', this.toggleDecreaseField.bind(this))
    })
  }

  toggleDecreaseField() {
    const decreaseField = document.getElementById('decrease-field')
    const primarySelected = this.criteriaTypeTargets.find(input => 
      input.checked && input.value === 'primary'
    )

    if (decreaseField) {
      if (primarySelected) {
        decreaseField.style.display = ''
      } else {
        decreaseField.style.display = 'none'
        // Сбрасываем значение на "Нет" при скрытии
        const noRadio = decreaseField.querySelector('input[value="false"]')
        if (noRadio) {
          noRadio.checked = true
        }
      }
    }
  }
}
